export const BASE_PATH_TO_RESELLER_LIST = "/reseller";
export const BASE_PATH_TO_ADD_RESELLER = "/reseller/add";